// @flow

import React, { Component } from 'react'
import { Button } from 'src/theme/globalStyle'

type Props = {
  text: string
}

export class BackButton extends Component<Props> {
  static contextTypes = {
    router: () => {}
  }

  render() {
    return (
      <Button onClick={this.context.router.history.goBack} narrow>
        {this.props.text}
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BackButton/index.js